import { render, staticRenderFns } from "./MigrationBanner.vue?vue&type=template&id=60e623fd&scoped=true&"
import script from "./MigrationBanner.vue?vue&type=script&lang=js&"
export * from "./MigrationBanner.vue?vue&type=script&lang=js&"
import style0 from "./MigrationBanner.vue?vue&type=style&index=0&id=60e623fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e623fd",
  null
  
)

export default component.exports